// This import loads the firebase namespace along with all its type information.
import QuickConnect from './quick-connect-model'

export async function load_quickConnects(): Promise<QuickConnect[]> {
  throw 'Not implemented'
}

export async function delete_quickConnect(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_quickConnect(): Promise<QuickConnect> {
  throw 'Not implemented'
}
